import React from 'react';
import './CardLabelsPage.styl';
import {List} from 'immutable';
import Loading from 'components/pure/utils/Loading';
import Button from '@material-ui/core/Button';
import ToggleField from 'components/pure/utils/form/ToggleField';
import {answersFor, naToNull, nullToNa, scorecardTypes} from 'records/Scorecard';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import {Card, CardText} from 'material-ui/Card';
import InputField from 'components/pure/utils/form/InputField';
import ToastStore from '@store/toast/ToastStore';

export default class CardLabelsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      labels: List(),
    };

    this.onChange = this.onChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    this.setState({
      labels: this.props.labels,
    });
  }

  onChange(updatedScheme) {
    const {labels} = this.state;

    const idx = labels.findIndex(i => i.scoringScheme === updatedScheme.scoringScheme);

    this.setState({
      labels: this.state.labels.set(idx, updatedScheme),
    });
  }

  onCancel() {
    this.setState({
      labels: this.props.labels,
    });
  }

  onSave() {
    const {labels} = this.state;
    const {onSave} = this.props;

    return onSave(labels.map(scheme => scheme.set('labels', naToNull(scheme.labels)))).then(
      ToastStore.addToast({
        type: 'success',
        time: 2000,
        message: 'Your scorecard scheme changes have been saved!',
      })
    );
  }

  renderButtons() {
    return (
      <div className="card-label-buttons">
        <Button variant="outlined" className="cancel-button ev-button" onClick={this.onCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          className="save-button ev-button"
          onClick={this.onSave}>
          Save
        </Button>
      </div>
    );
  }

  renderHeader() {
    return (
      <div className={'card-label-header'}>
        <div className={'scheme-column'}>
          <h3>Scoring Scheme</h3>
        </div>
        <div className={'options-column'}>
          <h3>Label Options</h3>
        </div>
        {this.renderButtons()}
      </div>
    );
  }

  render() {
    const {labels} = this.state;

    if (labels.size === 0) return <Loading />;

    return (
      <div className="card-labels-page">
        <h2>Scorecard Schemes</h2>

        <p>
          When you create a new scorecard, you can define the scoring scheme for the scorecard. You
          can pick from "1 to 5", "1 to 3", "Yes / No" and "Pass / Fail". If your organization has
          different labels for scores in these schemes, you can customize how these schemes are
          rendered in this screen. These labels are displayed above the score chooser on the
          scorecard screen, and in reports.
        </p>

        {this.renderHeader()}

        <div className="scheme-editor-wrapper">
          {['OneToFive', 'OneToThree', 'YesNo', 'PassFail', 'OneTwo'].map(scheme => (
            <SchemeEditor
              key={scheme}
              scheme={labels.find(l => l.scoringScheme === scheme)}
              onChange={this.onChange}
            />
          ))}
        </div>

        {this.renderButtons()}
      </div>
    );
  }
}

const SchemeEditor = ({scheme, onChange}) => {
  const pointValues = answersFor(scheme.scoringScheme);
  const naLabels = nullToNa(scheme.labels);

  // combine defaults from the updated scheme labels and defaults from the current state
  const zipped = pointValues.map(pv => {
    const updatedLabel = naLabels.find(l => l.point === pv.key);

    return {
      point: pv.key,
      label: updatedLabel ? updatedLabel.label : pv.header,
      key: pv.label,
    };
  });

  return (
    <Card className="scheme-editor">
      <CardText>
        <div className="inside-wrapper">
          <div className="scheme-column">
            <h3>{scorecardTypes[scheme.scoringScheme].label}</h3>
          </div>
          <div className="options-column">
            <ToggleField
              className="default-toggle"
              onToggle={(_, val) => onChange(scheme.set('default', !val))}
              toggled={!scheme.default}
              label="Allow Customization"
            />

            <div className={'options-wrapper'}>
              {zipped.map(label => (
                <FieldContainer label={'Label for "' + label.key + '"'} key={label.key}>
                  <InputField
                    onChange={value => {
                      const updatedLabel = {point: label.point, label: value};

                      // if we already included this label let's replace, otherwise add
                      const labelIdx = naLabels.findIndex(l => l.point === label.point);
                      const copy = naLabels.slice();
                      labelIdx !== -1
                        ? copy.splice(labelIdx, 1, updatedLabel)
                        : copy.push(updatedLabel);

                      const updatedScheme = scheme.set('labels', copy);
                      onChange(updatedScheme);
                    }}
                    value={label.label}
                    width={50}
                    disabled={scheme.default}
                  />
                </FieldContainer>
              ))}
            </div>
          </div>
        </div>
      </CardText>
    </Card>
  );
};
